module.exports = __webpack_public_path__ + "static/media/Issue_Update_Grey_Icon.a360368c.svg";